import React, { useState } from 'react';
import { useTranslation } from "react-i18next";

interface ProvinceDropdownProps {
    onChange: (updatedProvinceTerritoire: string) => void;
}

const ProvinceDropdown: React.FC<ProvinceDropdownProps> = ({ onChange }) => {
    const { t } = useTranslation();
    const provincesAndTerritories: string[] = [
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.AB"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.BC"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.PE"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.MB"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.NB"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.NS"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.ON"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.QC"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.SK"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.NL"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.NT"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.NU"),
        t("formulaireCommunicationRenseignement.coordonnees.informationsContact.provincesTerritoires.YT"),
    ];

    const [selectedProvince, setSelectedProvince] = useState<string | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedProvince(event.target.value);
        onChange(event.target.value,);
    };

    return (
        <select className="form-dropdown" value={selectedProvince || ''} onChange={handleChange}>
            <option value="">{t("formulaireCommunicationRenseignement.coordonnees.informationsContact.lblChampProvinceTerritoire")}</option>
            {provincesAndTerritories.map(province => (
                <option key={province} value={province}>
                    {province}
                </option>
            ))}
        </select>
    );
};

export default ProvinceDropdown;
